export enum PayVaultAPIResultType {
    success = 'success',
    failure = 'failure',
}

export interface IPayVaultAPIResponse {
    resultType: string;
}

export interface IPayVaultAPISuccessResponse extends IPayVaultAPIResponse {
    keyVersion: string;
    maskedCardDetails: {
        brandCode: string;
        cardToken: string;
        cardType?: string;
        expirationMonth: string;
        expirationYear: string;
        iin: string;
        issuerCode?: string;
        last4digits: string;
    };
    resultType: PayVaultAPIResultType.success;
    signature: string;
    timestamp: string;
}

export interface IPayVaultAPIFailureResponse extends IPayVaultAPIResponse {
    resultType: PayVaultAPIResultType.failure;
    errorCode: string;
    errorMessage: string;
}

export type PayVault = {
    setup: Function;
    destroy: Function;
    card: IPayVaultCard;
    openModal?: Function;
};

interface IPayVaultCard {
    cardType: Function;
    validateExpiration: () => Promise<boolean>;
    validateCardNumber: () => Promise<boolean>;
    getBrandCode: Function;
    createToken: Function;
    addEventListener: Function;
}

interface IPayVaultField {
    mount: string;
    styles: Record<string, any>;
    placeholder: string;
    format?: string;
    inputType?: string;
    brandCodes?: string[];
}

export interface IPayVaultEvent {
    brandCode: string;
    length: number;
    valid: boolean;
}
export interface IPayVaultElements {
    cardNumber: IPayVaultField;
    expirationMonth: IPayVaultField;
    expirationYear: IPayVaultField;
    cardScanModal?: { lang: string };
}
